export default "__VITE_ASSET__e0092094__"